import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../Base';
import { useDialogContext } from './DialogContext';
import { jsx as _jsx } from "react/jsx-runtime";
var styles = {
  "root": "DialogContent-root_3A7eZ",
  "scrollPaper": "DialogContent-scrollPaper_2l8ov"
};
function DialogContent({
  children,
  className,
  ...extraProps
}) {
  const {
    scroll
  } = useDialogContext('DialogContent');
  return /*#__PURE__*/_jsx(Base, {
    tagName: "section",
    flexAuto: true,
    className: clsx(styles.root, {
      [styles.scrollPaper]: scroll === 'paper'
    }, className),
    ...extraProps,
    children: children
  });
}
DialogContent.displayName = 'DialogContent';
export { DialogContent };